import Agent from '../../env/agent';
import { queryOptions, useQuery } from '@tanstack/react-query';

/**
 * Result for a query to /me
 *
 * This matches the response type from /auth/api/user/me
 *
 * {@link /companion-auth/src/app/api/user/userRoutes.ts}
 * See {@link IUserProfile}
 */
interface IMeResponse {
  profile: {
    email: string;
    fullName: string;
    firstName: string;
    lastName: string;
    salutation: string;
    mobilePhone: string;
    address: string;
    postCode: string;
    accountType: 'individual' | 'business';
    city: string;
    state: string;
    hasMarketingConsent: boolean;
    vatNumber?: string;
    businessName?: string;
    tradingName?: string;
    homeLocation?: number; // Where they live in Nexudus
    lastAccess?: string;
    companyNumber?: string;
    homeLocationName?: string;
    flags: Record<string, boolean>;
    /** Gym waiver state, computed live by companion-auth (see UserRoutes.respondWithuser). */
    gymWaiver?: 'valid' | 'expiring_soon' | 'not_found';
    gymWaiverExpiryDate?: string;
  };
}

export function meQueryOptions(agent: Agent, loggedInSub: string | undefined) {
  return queryOptions({
    queryKey: ['enhancedUser', 'me', loggedInSub],
    queryFn: () => agent.EnhancedUser.me() as Promise<IMeResponse>,
    enabled: !!loggedInSub,
  });
}

export function useMeQuery(agent: Agent, loggedInSub: string | undefined) {
  return useQuery(meQueryOptions(agent, loggedInSub));
}

export function useMeHasFlagQuery(
  agent: Agent,
  loggedInSub: string | undefined,
  flag: string,
) {
  return useQuery({
    ...meQueryOptions(agent, loggedInSub),
    select: (data: IMeResponse) => data.profile.flags[flag] || false,
  });
}
